// @flow
import api from 'tim-api';
import { storeInfo, planInfo, saveReportTerm } from 'endPoints';

const updateLocalStorage = () => {
  localStorage.setItem('vuexTerm', JSON.stringify(state.term));
}

const getDefaultState = () => ({
  posVenda: {},
  justDependent: false,
  plan: 'fatura',
  tipoVenda: 'venda',
  tipoServico: 'smp',
  pessoa: 'fisica',
  tipoPermanecia: '',
  changeDate: false,
  customer: {
    transferencia: {
      hasRepresentative: false,
      hasProcuration: false,
      gender: 'feminino',
      procurator: {},
      nationality: 'brasileira',
      messageTerm: 'sim',
      term: {},
      illiterate: false,
      installAddressSame: true
    },
    hasRepresentative: false,
    hasProcuration: false,
    gender: 'feminino',
    procurator: {},
    nationality: 'brasileira',
    messageTerm: 'sim',
    messageTAC: 'sim',
    messageBiometry: 'nao',
    term: {},
    illiterate: false,
    installAddressSame: true,
    exemptCompany: false
  },
  service2: {
    hasVoip: false,
    loyalty: null,
    additionalPrice: 0,
    additionalServices: '',
    aditionalServiceValue1: 0,
    aditionalVoipService1: '',
    aditionalServiceValue2: 0,
    aditionalVoipService2: '',
    portability: {
      hasPortability: false
    },
    plan: {
      dependents: 5
    }
  },
  service: {
    hasVoip: false,
    loyalty: null,
    additionalPrice: 0,
    additionalServices: '',
    aditionalServiceValue1: 0,
    aditionalVoipService1: '',
    aditionalServiceValue2: 0,
    aditionalVoipService2: '',
    portability: {
      hasPortability: false
    },
    plan: {
      dependents: 5
    },
    mudancaPlano: {
      hasVoip: false,
      loyalty: null,
      portability: {
        hasPortability: false
      },
      plan: {
        dependents: 5
      }
    },
    ativacaoServicoAdicional: {
      hasVoip: false,
      loyalty: null,
      portability: {
        hasPortability: false
      },
      plan: {
        dependents: 5
      }
    },
    desativacaoServico: {
      hasVoip: false,
      loyalty: null,
      portability: {
        hasPortability: false
      },
      plan: {
        dependents: 5
      }
    },
    trocaChip: {
      hasVoip: false,
      loyalty: false,
      portability: {
        hasPortability: false
      },
      plan: {
        dependents: 5
      }
    },
    mudancaNumero: {
      hasVoip: false,
      loyalty: null,
      portability: {
        hasPortability: false
      },
      plan: {
        dependents: 5
      }
    },
    trocaAparelho: {
      hasVoip: false,
      loyalty: null,
      portability: {
        hasPortability: false
      },
      plan: {
        dependents: 5
      }
    }
  },
  payment: {
    canalVenda: 'TIM STORE PROPRIA',
    issueDate: 1,
    type: 'debit',
    invoiceType: 'online',
    shareTerm: true,
    cardConfirmation: false,
    plans: [],
    plans2: [],
    storeId: '',
    storeName: ''
  },
  dependents: [],
  planos: [],
  lojas: [],
  placesFiltered: [],
  update: 0,
  restoreData: null
});

export const state: Object = {
  term: getDefaultState()
};

export const getters = {
  term: (state: Object) => state.term,
  restoreData: (state: Object) => state.term.restoreData
};

export const mutations = {
  SET_RESTORE_DATA(state: Object, restoreData: Object) {
    state.term.restoreData = { ...state.term.restoreData, ...restoreData };
  },
  SET_CUSTOMER(state: Object, customer: Object) {
    state.term.customer = { ...state.term.customer, ...customer };
    updateLocalStorage();
  },
  SET_SERVICE(state: Object, service: Object) {
    state.term.service = { ...state.term.service, ...service };
    updateLocalStorage();
  },
  SET_SERVICE_2(state: Object, service: Object) {
    state.term.service2 = { ...state.term.service2, ...service };
    updateLocalStorage();
  },
  SET_TERM_ATTR(state: Object, { attr, value }: Object) {
    const newAttr = {};
    newAttr[attr] = value;
    state.term = { ...state.term, ...newAttr };
    updateLocalStorage();
  },
  SET_PAYMENT(state: Object, payment: Object) {
    state.term.payment = { ...state.term.payment, ...payment };
    updateLocalStorage();
  },
  SET_TERM(state: Object, term: Object) {
    state.term = { ...state.term, ...term };
    updateLocalStorage();
  },
  SET_DEPENDENT(state: Object, dependent: Object) {
    state.term.dependents = dependent;
    updateLocalStorage();
  },
  RESET_TERM(state: Object) {
    Object.assign(state.term, getDefaultState());
    updateLocalStorage();
  },
  RESET_DEPENDENT(state: Object) {
    state.term.dependents = [];
    updateLocalStorage();
  },
  SET_UPDATE(state: Object) {
    state.term.update++;
    updateLocalStorage();
  }
};

export const actions = {
  setRestoreData({ commit }: Action, restoreData: Object) {
    commit('SET_RESTORE_DATA', restoreData);
  },
  setCustomer({ commit }: Action, payload: Object): void {
    commit('SET_CUSTOMER', payload);
  },
  setPayment({ commit }: Action, payload: Object): void {
    commit('SET_PAYMENT', payload);
  },
  setService({ commit }: Action, payload: Object): void {
    commit('SET_SERVICE', payload);
  },
  setService2({ commit }: Action, payload: Object): void {
    commit('SET_SERVICE_2', payload);
  },
  setDependent({ commit }: Action, payload: Object): void {
    commit('SET_DEPENDENT', payload);
  },
  setTermAttr({ commit }: Action, payload: Object): void {
    commit('SET_TERM_ATTR', payload);
  },
  setTerm({ commit }: Action, payload: Object): void {
    commit('SET_TERM', payload);
  },
  resetTerm({ commit }: Action): void {
    commit('RESET_TERM');
  },
  resetDependent({ commit }: Action): void {
    commit('RESET_DEPENDENT');
  },
  getStoreInfo({ commit }: Action, payload: Object) {
    return api.get(`${storeInfo}/${payload.tipo}/${payload.nome}`);
  },
  getPlansInfo({ commit }: Action, payload: Object) {
    return api.get(
      `${planInfo}/${payload.canal}/${payload.tipo}/${payload.produto}/${payload.ddd}/${payload.isDependent
      }/?withOldPlans=${payload.withOldPlans
      }`
    );
  },
  savePlanInfo({ commit }: Action, payload: Object) {
    if (payload.tipoVenda === 'venda') {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: payload.tipoServico,
        tipoServicoPosVenda: '',
        produto: payload.plan,
        plano: payload.service.plan.name,
        tipoFatura: payload.payment.type,
        tastingPlan: payload.service.plan.tastingPlanValue
      }); // passa todo objeto para o API
    }
    if (payload.posVenda.isAtivacaoAdicional) {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: '',
        tipoServicoPosVenda: 'Ativação Serviço Adicional',
        produto: '',
        plano: '',
        tipoFatura: ''
      }); // passa todo objeto para o A
    }

    if (payload.posVenda.isDesativacao) {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: '',
        tipoServicoPosVenda: 'Desativação de Serviço Adicional',
        produto: '',
        plano: '',
        tipoFatura: ''
      }); // passa todo objeto para o A
    }

    if (payload.posVenda.isMudancaNumero) {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: '',
        tipoServicoPosVenda: 'Mudança de Número',
        produto: '',
        plano: '',
        tipoFatura: ''
      }); // passa todo objeto para o A
    }

    if (payload.posVenda.isTrocaChip) {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: '',
        tipoServicoPosVenda: 'Troca de Chip',
        produto: '',
        plano: '',
        tipoFatura: ''
      }); // passa todo objeto para o A
    }

    if (payload.posVenda.isMudancaPlano) {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: '',
        tipoServicoPosVenda: 'Mudança de Plano',
        produto: '',
        plano: payload.service.mudancaPlano.plan.name,
        tipoFatura: ''
      }); // passa todo objeto para o A
    }

    if (payload.posVenda.isTransferencia) {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: payload.tipoServico,
        tipoServicoPosVenda: 'Transferencia de Titularidade',
        produto: payload.plan,
        plano: '',
        tipoFatura: payload.payment.type
      }); // passa todo objeto para o A
    }

    if (payload.posVenda.isTrocaAparelho) {
      return api.post(`${saveReportTerm}`, {
        canal: payload.payment.canalVenda,
        regional: '',
        custcode: payload.payment.storeId,
        login: payload.payment.matricula,
        nomeUsuario: payload.payment.sellerName,
        tipoVenda: payload.tipoVenda,
        tipoServicoVenda: payload.tipoServico,
        tipoServicoPosVenda: 'Troca de Aparelho',
        produto: payload.plan,
        plano: '',
        tipoFatura: payload.payment.type,
        migracaoPlano: payload.migrationPayload
      }); // passa todo objeto para o A
    }
  },
  downloadReport(context: Action, payload: Object) {
    return api
      .get(`${'termo/download'}${payload}`, {
        responseType: 'blob'
      })
      .catch(async err => {
        const errorData = await getBlobError(err);

        throw errorData;
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
